<template>
    <div>
      <h3>Verify Ownership</h3>
      <p class="eligibility_label">
        Check the eligibility of <b>{{ company_name }}</b> in 60 seconds
      </p>
      <Dropdown
        :inputField="inputs.srfico"
        :options="ficoOptions"
        inputName="Your Estimated Credit Score"
        inputType="string"
      />
      <Input
        @enter="next"
        :inputField="inputs.federal_tax_id"
        inputName="Federal Tax ID (EIN)"
        placeholder="XX-XXXXXXX"
        inputType="ein"
        obj="business"
        v-if="isNeeded('federal_tax_id')"
      />
      <Input
        @enter="next"
        :inputField="inputs.ssn"
        inputName="Social Security Number (SSN)"
        placeholder="XXX-XX-XXXX"
        inputType="ssn"
        :icons="{ right: 'fa-lock' }"
        v-if="isNeeded('ssn')"
      />
      <p style="font-variant-caps: all-petite-caps; font-size: 0.8rem">
        We use encryption to protect your personal information.
      </p>
      <AddressInput
        :inputField="inputs.address"
        inputName="Home Address"
        inputType="string"
        @selectedAddress="updateAddress"
        v-if="isNeeded('pg_address')"
      />
      <Input
        @enter="next"
        :inputField="inputs.city"
        inputName="City"
        inputType="string"
        ref="city"
        v-if="isNeeded('pg_city')"
      />
      <Input
        @enter="next"
        :inputField="inputs.state"
        inputName="State"
        inputType="state"
        ref="state"
        v-if="isNeeded('pg_state')"
      />
      <Input
        @enter="next"
        :inputField="inputs.zip"
        inputName="Zip Code"
        inputType="zip"
        ref="zip"
        v-if="isNeeded('pg_zip')"
      />
      <h3 v-if="isNeeded('date_of_birth')">Date of Birth</h3>
      <DatePicker :inputField="inputs.dob" inputName="DOB" inputType="string"  v-if="isNeeded('date_of_birth')"/>
      <div class="buttons is-right">
        <!-- <a v-if="!validate" class="button is-link is-inverted padded-button next-button" @click="back">Back</a> -->
        <a class="button is-link padded-button next-button" @click="next"
          >Continue</a
        >
      </div>
    </div>
  </template>
  
  <script>
  import Input from "@/components/shared/Input";
  import AddressInput from "@/components/shared/AddressInput";
  import Dropdown from "@/components/shared/Dropdown";
  import DatePicker from "@/components/shared/DatePicker";
  import ApplyPage from "@/components/shared/ApplyPage";
  
  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }
  
  export default {
    name: "IncompleteAppOwnershipFields",
    components: {
      Input,
      AddressInput,
      DatePicker,
      Dropdown,
    },
    props: {
      fields_incomplete: Array
    },
    mixins: [ApplyPage],
    data() {
      return {
        obj: "pg",
        ficoOptions: [
          "Less than 525",
          "550",
          "575",
          "600",
          "625",
          "650",
          "675",
          "700+",
        ],
        inputs: {
          federal_tax_id: Input.model(),
          ssn: Input.model(),
          address: AddressInput.model(),
          city: Input.model(),
          state: Input.model(),
          zip: Input.model(),
          dob: Input.model(),
          srfico: Input.model(),
          tags: [],
        },
        company_name: "",
        show_address_fields: true,
        selected_address: false,
        full_address: "Please type and select your business address",
      };
    },
    mounted: function () {
      // let company_name = getWithExpiry("company_name");
      // this.company_name = company_name;
  
      // let tid = getWithExpiry("tid");
      // this.inputs.tid.value = tid;
  
      // let srfico = getWithExpiry("srfico");
      // this.inputs.srfico.value = srfico;
  
      // let zip = getWithExpiry("zip");
      // this.inputs.zip.value = zip;

      console.log('fields incomplete:', this.fields_incomplete);
    },
    methods: {
      isNeeded(inputId) {
        // console.log(inputId);
      // Check if the input ID is in the hiddenInputs array
        return this.fields_incomplete.includes(inputId);
      },
      updateAddress: function (data) {
      // console.log(data);
      this.inputs.city.value = data.city;
      this.inputs.state.value = data.state;
      this.inputs.zip.value = data.zip;
      if (
        data.city &&
        data.city !== "" &&
        data.state &&
        data.state !== "" &&
        data.state &&
        data.state !== ""
      ) {
        // this.show_address_fields = false;
        this.selected_address = true;
        this.full_address =
          data.street_number +
          " " +
          data.street +
          ", " +
          data.city +
          ", " +
          data.state +
          ", " +
          data.zip;
      }
    },
    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .iff-notification {
    animation-name: notify;
    animation-duration: 8s;
    width: 100%;
    position: fixed;
    top: -100px;
    opacity: 0;
    left: 0px;
    z-index: 3;
    background: #3273dc;
    text-align: center;
    color: white;
    /* padding: 5px; */
    padding: 5px 10px;
    font-size: 14px;
  }
  
  @keyframes notify {
    5% {
      top: -100px;
      opacity: 0;
    }
    12.5% {
      top: 0px;
      opacity: 1;
    }
    92.5% {
      top: 0px;
    }
    100% {
      top: -100px;
      opacity: 1;
    }
  }
  .eligibility_label {
    font-weight: 500;
  }
  </style>
  